import Flip from './behaviors/flip/Flip.js';
export default Flip;